import React, {memo, useEffect, useState} from 'react';
import {Select} from 'antd';
import {useInputWithFocus} from 'common/hook/useInputWithFocus';
import {optionsTextOfQuestion} from 'components/form/options/options';
import {FieldsRow} from "../general/fields-row/FieldsRow";
import {ReactComponent as SelectArrayIcon} from '../../../../../../../../../assets/i/select-array-icon.svg';
import {ReactComponent as ArrowUpIconIcon} from '../../../../../../../../../assets/i/arrow-up-icon.svg';
import {ReactComponent as InfoSmallerIcon} from '../../../../../../../../../assets/main/test/info-smaller.svg';
import TextArea from "antd/es/input/TextArea";
import {useAppDispatch} from "common/hook";
import {Answer, setTextTabData, TestItem} from "features/model/slice/create-test/create-test-form/createTestForm";

import {useParams} from "react-router-dom";


interface IPropsType {
    questionData?: TestItem;
}


export const TextTab = memo(({questionData}: IPropsType) => {

    const dispatch = useAppDispatch()
    const [open, setOpen] = useState<boolean>(false);
    const {isFilled, handleFocus, handleBlur} = useInputWithFocus([false, false, false, false, false,false]);

    const [values, setValues] = useState<TestItem>(questionData as TestItem || {});

    useEffect(() => {
        if (questionData) {
            setValues({
                ...questionData,
                tabType: 'textType',
            });
        }
    }, [questionData?.id, questionData?.tabType, questionData?.file?.path, questionData?.file?.fileName]);




    useEffect(() => {
        dispatch(setTextTabData({
            ...values,
            tabType: 'textType',
        }));
    }, [values, dispatch]);



    useEffect(() => {
        if (values.questionType === 'determineProcedure') {
            setValues((prevValues) => ({
                ...prevValues,
                before: '',
                after: '',
                afterSecond: '',
                file: {
                    path:'',
                    fileName:'',
                }
            }));
        }
    }, [values.questionType]);


    const handleChange = (name: string, value: string,) => {
        setValues((prevValues) => ({
            ...prevValues,
            [name]: value,
        }));
    };


    const renderBlocks = () => {
        if (values.questionType === 'withoutSkipping') {
            return (
                <div className="field large-w">
                    <div style={{width: '100%'}} className={`field ${isFilled[0] ? 'filled' : ''}`}>
                        <label className={`field-name ${values.questionTitle ? 'active-label' : ''}`}>
                            Текст вопроса
                        </label>
                        <div className="ant-select-selector">
                            <TextArea
                                name="questionTitle"
                                className="form-control  form-control-new"
                                value={values.questionTitle}
                                onChange={(event) => handleChange('questionTitle', event.target.value)}
                                onFocus={() => handleFocus(0)}
                                onBlur={handleBlur}
                                autoSize={{minRows: 1, maxRows: 10}}
                            />
                        </div>
                    </div>
                </div>
            );
        } else if (values.questionType === 'singleSpaced') {
            return (
                <>
                    <div className="field large-w">
                        <div style={{width: '100%'}} className={`field ${isFilled[1] ? 'filled' : ''}`}>
                            <label className={`field-name ${values.before ? 'active-label' : ''}`}>
                                Текст вопроса до пропуска
                            </label>
                            <div className="ant-select-selector">
                                <TextArea
                                    name="before"
                                    className="form-control form-control-new"
                                    value={values.before}
                                    onChange={(event) => handleChange('before', event.target.value)}
                                    onFocus={() => handleFocus(1)}
                                    onBlur={handleBlur}
                                    autoSize={{minRows: 1, maxRows: 10}}
                                />
                            </div>
                        </div>
                        <div style={{width: '100%'}} className={`field ${isFilled[2] ? 'filled' : ''}`}>
                            <label className={`field-name ${values.after ? 'active-label' : ''}`}>
                                Текст вопроса после первого пропуска
                            </label>
                            <div className="ant-select-selector">
                                <TextArea
                                    name="after"
                                    className="form-control form-control-new"
                                    value={values.after}
                                    onChange={(event) => handleChange('after', event.target.value)}
                                    onFocus={() => handleFocus(2)}
                                    onBlur={handleBlur}
                                    autoSize={{minRows: 1, maxRows: 10}}
                                />
                            </div>
                        </div>
                    </div>
                </>
            );
        } else if (values.questionType === 'doublePassed') {
            return (
                <>
                    <div className="field large-w">
                        <div style={{width: '100%'}} className={`field ${isFilled[1] ? 'filled' : ''}`}>
                            <label className={`field-name ${values.before ? 'active-label' : ''}`}>
                                Текст вопроса до пропуска
                            </label>
                            <div className="ant-select-selector">
                                <TextArea
                                    name="before"
                                    className="form-control form-control-new"
                                    value={values.before}
                                    onChange={(event) => handleChange('before', event.target.value)}
                                    onFocus={() => handleFocus(3)}
                                    onBlur={handleBlur}
                                    autoSize={{minRows: 1, maxRows: 10}}
                                />
                            </div>
                        </div>

                        <div style={{width: '100%'}} className={`field ${isFilled[2] ? 'filled' : ''}`}>
                            <label className={`field-name ${values.after ? 'active-label' : ''}`}>
                                Текст вопроса после первого пропуска
                            </label>
                            <div className="ant-select-selector">
                                <TextArea
                                    name="speaking"
                                    className="form-control form-control-new"
                                    value={values.after}
                                    onChange={(event) => handleChange('after', event.target.value)}
                                    onFocus={() => handleFocus(4)}
                                    onBlur={handleBlur}
                                    autoSize={{minRows: 1, maxRows: 10}}
                                />
                            </div>
                        </div>
                        <div style={{width: '100%'}} className={`field ${isFilled[3] ? 'filled' : ''}`}>
                            <label className={`field-name ${values.afterSecond ? 'active-label' : ''}`}>
                                Текст вопроса после второго пропуска
                            </label>
                            <div className="ant-select-selector">
                                <TextArea
                                    name="afterSecond"
                                    className="form-control form-control-new"
                                    value={values.afterSecond}
                                    onChange={(event) => handleChange('afterSecond', event.target.value)}
                                    onFocus={() => handleFocus(5)}
                                    onBlur={handleBlur}
                                    autoSize={{minRows: 1, maxRows: 10}}
                                />
                            </div>
                        </div>
                    </div>
                </>
            );
        }
        else if (values.questionType === 'determineProcedure') {
            return (
                <div className="field large-w">
                    <div style={{width: '100%'}} className={`field ${isFilled[1] ? 'filled' : ''}`}>
                        <label className={`field-name ${values.questionTitle ? 'active-label' : ''}`}>
                            Текст вопроса
                        </label>
                        <div className="ant-select-selector">
                            <TextArea
                                name="questionTitle"
                                className="form-control form-control-new"
                                value={values.questionTitle}
                                onChange={(event) => handleChange('questionTitle', event.target.value)}
                                onFocus={() => handleFocus(6)}
                                onBlur={handleBlur}
                                autoSize={{minRows: 1, maxRows: 10}}
                            />
                        </div>
                    </div>
                </div>
            )
        }
    };

    return (
        <>
            <div className="fields-row two-cols">
                <div className="field middle-w">
                    <div className="course-type" onClick={() => setOpen(!open)}>
                        <span className={values.questionType ? 'active-label' : ''}>Тип вопроса</span>
                        <Select
                            style={{width: '100%'}}
                            value={values.questionType}
                            className="custom-select select-new"
                            onChange={(value) => handleChange('questionType', value.toString())}
                            options={optionsTextOfQuestion}
                            onFocus={() => handleFocus(0)}
                            onBlur={handleBlur}
                            suffixIcon={open ? <ArrowUpIconIcon/> : <SelectArrayIcon/>}
                        />
                    </div>
                </div>
                {renderBlocks()}
            </div>
            {values.questionType === 'determineProcedure' &&
                <p className="p-icon info-icon">
                    Сначала введите правильный порядок слов или фраз, а затем перемешайте последовательность.
                    <span className="icon">
                        <InfoSmallerIcon/>
                </span>
                </p>
            }
            <FieldsRow values={values}/>
        </>
    );
});
